module.exports = __webpack_public_path__ + "img/daniel_side.8ee1c75a.png";